import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Card, Button } from 'antd'
import '../../css/regimen.scss'
import { useLocation } from 'react-router'
import { assignDevices, assignPlan } from '../../store/action/device.action'
import { getHelp, pages } from '../../tutorials'
import { setNewPatient } from '../../store/action/patient.action'

const DeviceCard = (props) => {
  var [selected, setSelected] = useState(false)
  useEffect(() => {
    console.log(props)
    setSelected(props.assignedPlan._id == props.plan._id)
  }, [props.assignedPlan])

  useEffect(() => {
    if (!props.isLoading) getHelp(pages.SELECTCAREPLAN)
  }, [props.isLoading])

  useEffect(() => {
    //if devices and careplan are both populated in the redux state
    //and if only one care plan exists assign that to the patient
    if (
      props.devices &&
      props.careplans &&
      props.devices.length > 0 &&
      props.careplans.length == 1
    )
      handleAssignClick()
  }, [props.careplans, props.devices])

  var handleAssignClick = () => {
    // Devices are scoped per surgery type, mirroring self-registration
    // (patientselfregistration.js): only assign devices whose careplan
    // scheduletemplate entry is tagged with THIS patient's surgery type.
    // Legacy untyped entries are ignored (hard cutover). Before this,
    // the wizard assigned the careplan's full deviceids union across all
    // surgery types, silently over-assigning (e.g. the Tenovi Watch).
    const surgeryType = props.newPatient?.surgery?.type
    const allowedDeviceIds = {}
    ;(props.plan.scheduletemplate || []).forEach((s) => {
      if (s.deviceid && s.surgerytype === surgeryType)
        allowedDeviceIds[String(s.deviceid)] = true
    })
    const devlist = props.plan.deviceids
      .filter((dev) => allowedDeviceIds[String(dev._id)])
      .map((dev) => {
        return props.devices.filter((i) => i._id == dev._id)[0]
      })
      .filter(Boolean)
    props.assignDevices(devlist)
    props.assignPlan({ ...props.plan })
    if (props.newPatient && props.plan._id) props.setNewPatient({...props.newPatient,careplan:props.plan._id})
  }

  var renderHeader = () => (
    <Row className='cardHeader' align='middle'>
      <Col>
        <h3>{props.plan?.name?.toUpperCase()}</h3>
      </Col>
      <Col hidden={props.hideBtn} style={{ marginLeft: 'auto' }}>
        <Button
          className='assignBtn'
          onClick={() => handleAssignClick()}
          disabled={selected}
        >
          {selected ? 'Selected' : 'Select'}
        </Button>
      </Col>
    </Row>
  )
  var renderCareplan = () => {
    return props.plan ? (
      <>
        <Row className='exerRowNoBorder'>
          {' '}
          <Col>{props.plan.description} </Col>
        </Row>
        {props.plan.deviceids.length > 0 && (
          <Row className='exerRowNoBorder'>
            {' '}
            <Col className='exerHeader'>Devices Included</Col>
          </Row>
        )}

        {props.plan.deviceids.map((dev) => {
          return (
            <Row className='exerRowNoBorder' align='middle'>
              <Col>
                <Row>&#9679; {dev.display_name}</Row>
              </Col>
            </Row>
          )
        })}
      </>
    ) : null
  }

  return (
    <Card
      id={'choosecareplan'}
      bordered={false}
      title={!props.hideHeader ? renderHeader() : null}
      className='regimenCard'
    >
      <Row className='dateHeader divide'>
        Description
        {props.hideHeader ? <Col></Col> : null}
      </Row>
      <Row>
        <Col style={{ width: '100%' }}>{renderCareplan()}</Col>
      </Row>
    </Card>
  )
}

DeviceCard.propTypes = {
  company: PropTypes.object,
  device: PropTypes.object,
  assigned: PropTypes.bool,
  hideBtn: PropTypes.bool,
  hideHeader: PropTypes.bool,
  assignedRegs: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    assignedPlan: state.device.assignedPlan,
    devices: state.device.devices,
    careplans: state.device.careplans,
    isLoading: state.device.isLoading,
    newPatient: state.patient.newpatient,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    assignDevices: (devices) => dispatch(assignDevices(devices)),
    assignPlan: (plan) => dispatch(assignPlan(plan)),
    setNewPatient: (patient) => dispatch(setNewPatient(patient)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceCard)
